import api from "./api";

const exchangeService = {
    getDetailsByToken: (jwttoken, activeTokenId) =>
        api.get('/exchange-details/' + activeTokenId, {
            headers: { 'Authorization': `Basic ${jwttoken}` }
        }),
    getOrders: (jwttoken) =>
        api.get('/exchange-order/myorder', {
            headers: { 'Authorization': `Basic ${jwttoken}` }
        }),
    getOrdersByActive: (jwttoken, activeId) =>
        api.get('/exchange-order/myorder/'+activeId, {
            headers: { 'Authorization': `Basic ${jwttoken}` }
        }),

    cancelOrder: (jwttoken, orderId) =>
        api.delete('/exchange-order/' + orderId, {
            headers: { 'Authorization': `Basic ${jwttoken}` }
        }),
    cancelOrderBinance: (jwttoken, orderId) =>
        api.delete('/exchange-order/delete-binance/' + orderId, {
            headers: { 'Authorization': `Basic ${jwttoken}` }
        })
    
};

export default exchangeService;